const layout = {
  sideBar: {
    menu: {
      more: {
        children: {
          shifts: 'School Hours',
        },
      },
    },
  },
};

export default layout;
